import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import searchIcon from '../../../assets/icons/search-icon-dark.svg';
import locationIcon from '../../../assets/icons/location-pin.svg';
import {clubFinderSearchBarSliceActions} from "../../../../store/slices/clubFinderSearchBarSlice";
import {RootState} from "../../../../store/configureStore";
import './mobile-filter-button.scss';
import searchIconLight from "../../../assets/icons/search-icon-light.svg";
import {clubFinderMapResultSliceActions} from "../../../../store/slices/clubFinderResultMapSlice";
import Loader from "../../Loader/loader";
import {getSelectedFilterCount} from "../../../../utilities/getSelectedFilterCount";
import {AppVersionForTenants, TenantAppVersionConfig} from "../../../../constants/Config";

const baseClass = 'clubFinder-mobile-filter-button'

interface MobileFilterButtonTypes {
  location: string | null,
  format: string | null,
  for: string | null,
  tenant: string
}

const MobileFilterButton = (props: MobileFilterButtonTypes): JSX.Element => {
  const dispatch = useDispatch();
  const isMobileSearchVisible = useSelector((state: RootState) => state.clubFinderSearchBarStore.isMobileSearchVisible);
  const selectedFormatFilterName = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedFormatFilterName);
  const selectedMultiGenderFilters = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedMultiGenderFilters);
  const selectedInclusionFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedInclusionFilters);
  const selectedDaysFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedDayFilters);
  const toggleUserLocationFunction = useSelector((state: RootState) => state.clubFinderMapResultStore.toggleUserLocationFunction);
  const isUserLocationSearching = useSelector((state: RootState) => state.clubFinderSearchBarStore.isUserLocationSearching);

  const toggleFilter = (filterVisibility: boolean) => {
    if (!filterVisibility) {
      window.scroll(0, 0);
    }
    dispatch(clubFinderSearchBarSliceActions.toggleMobileSearch(!filterVisibility));
  }

  const openFilterDrawer = (event: any) => {
    event.stopPropagation();
    try {
      dispatch(clubFinderSearchBarSliceActions.toggleFilterDrawerVisibility(true));
    } catch (e) {
      console.log("Error opening filter:", e);
    }
  }

  const getUserCurrentLocation = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(clubFinderMapResultSliceActions.callGetUserLocationFunction(!toggleUserLocationFunction));
  }

  const totalSelectedFilters = getSelectedFilterCount(selectedFormatFilterName, selectedMultiGenderFilters, selectedInclusionFilter, selectedDaysFilter);

  return (
    <div className={`${baseClass}--mobile-toggle`} onClick={() => toggleFilter(isMobileSearchVisible)}>
      {isUserLocationSearching && AppVersionForTenants.v2.tenants.includes(props.tenant) && (
        <Loader/>
      )}

      {!isUserLocationSearching && (
        <img src={props.tenant == 'nzc' ? searchIcon : locationIcon} className={`${baseClass}--mobile-toggle-icon`}
             alt="search" onClick={AppVersionForTenants.v2.tenants.includes(props.tenant) ? getUserCurrentLocation : undefined}/>
      )}
      <div className={`${baseClass}--mobile-toggle-label`}>
        {props.location && (
          <div className={`${baseClass}--mobile-toggle-label-title`}>{props.location}</div>
        )}
        {(props.for || props.format) && (
          <div className={`${baseClass}--mobile-toggle-label-sub-title`}>{props.format} - {props.for}</div>
        )}
      </div>
      {AppVersionForTenants.v2.tenants.includes(props.tenant) && (
        <div
          className={`${baseClass}--search-button ${baseClass}--search-button-searchable`}>
          <button>
            <img src={searchIconLight} alt={'search icon'}/>
          </button>
        </div>
      )}
      {AppVersionForTenants.v2.tenants.includes(props.tenant) && (
        <div
          className={`${baseClass}--filter-button ${totalSelectedFilters > 0 ? 'filters-selected' : ''}`}>
          <button onClick={(event) => openFilterDrawer(event)}>
            <img src={TenantAppVersionConfig[props.tenant].icons.settings} alt={'settings-icon'}/>
            {totalSelectedFilters > 0 && (
              <span className={'filter-count'}>{totalSelectedFilters}</span>
            )}
          </button>
        </div>
      )}
    </div>
  )
}

export default MobileFilterButton;
